<div
  class="flex h-full w-full flex-col items-center gap-4 overflow-scroll bg-[#fafafa] px-1 pb-1 pt-4 md:px-4"
>
  <div class="w-full max-w-7xl">
    <router-outlet />
  </div>

  <div class="my-4 flex flex-col items-center gap-1">
    <a
      href="https://principle.dental"
      target="_blank"
      class="text-xs !text-gray-500"
    >
      Powered By <span class="font-bold">Principle</span>
    </a>
    <div class="text-xs !text-gray-500">
      This site is protected by reCAPTCHA and the Google
      <a href="https://policies.google.com/privacy" target="_blank">
        Privacy Policy
      </a>
      and
      <a href="https://policies.google.com/terms" target="_blank">
        Terms of Service
      </a>
      apply.
    </div>
  </div>
</div>
